import { render, staticRenderFns } from "./VehicleDetailsModal.vue?vue&type=template&id=535d5d99"
import script from "./VehicleDetailsModal.vue?vue&type=script&lang=js"
export * from "./VehicleDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./VehicleDetailsModal.vue?vue&type=style&index=0&id=535d5d99&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports